import classNames from 'classnames'
import { NextPageContext } from 'next'
import { useEffect, useState } from 'react'
import Button from '../../../components/_legacy/Button'
import Col from '../../../components/basic/Col'
import CenterContainer from '../../../components/common/CenterContainer'
import EmptyBlock from '../../../components/common/EmptyBlock'
import Footer from '../../../components/common/Footer'
import { FeatherChevronLeft } from '../../../components/common/Icons'
import VWContainer from '../../../components/common/VWContainer'
import NewBasicContainer from '../../../components/container/NewBasicContainer'
import TailwindWrapper from '../../../components/container/TailwindWrapper'
import { IOgData } from '../../../components/landing/blog/type'
import { InitialProps } from '../../../model/Common/common.interface'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import LinkLocale from '../../../modules/i18n/LinkLocale'
import { LOCALE_KO } from '../../../modules/i18n/config'
import useTranslation from '../../../modules/i18n/useTranslation'
import { IC_HOME, TEAM_MAIN } from '../../../modules/images'
import urls from '../../../modules/urls'
import { getOgUrl } from '../../../modules/utils'

type MemberCardPropsType = {
  member: any
}

const MemberCard = ({ member }: MemberCardPropsType) => {
  const [memberFocus, setMemberFocus] = useState(false)
  const lead = member?.lead
  const { isLocaleKO } = useTranslation()
  const [changingText, setChangingText] = useState(isLocaleKO ? member?.intro : member?.intro_en)
  const [changingImg, setChangingImg] = useState(member?.gray_image_url)
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const showCasualIntro = () => {
    setMemberFocus(true)
    setChangingText(isLocaleKO ? member?.casual_intro : member?.casual_intro_en)
    setChangingImg(member?.color_image_url)
  }
  const hideCasualIntro = () => {
    setMemberFocus(false)
    setChangingText(isLocaleKO ? member?.intro : member?.intro_en)
    setChangingImg(member?.gray_image_url)
  }

  return (
    <>
      {isMobile ? (
        <>
          <hr className="m-0" />
          <div
            onMouseEnter={() => showCasualIntro()}
            onMouseLeave={() => hideCasualIntro()}
            className="row transition-all-200 member-card-sm bg-white pt-[8px] pb-[20px]"
          >
            <Col cond={'mb-12 col-3 justify-center p-0'}>
              <div className="overflow-hidden rounded-full">
                <img
                  onContextMenu={(e) => e.preventDefault()}
                  src={changingImg}
                  className={'pointer-events-none bg-gray-200'}
                />
              </div>
            </Col>
            <Col clx={'col-8 ml-3 pr-0'}>
              <div className={classNames('link-icons absolute top-0 right-0', 'flex')}>
                {member?.homepage && (
                  <a href={member?.homepage} className="">
                    <img src={IC_HOME} width={22} />
                  </a>
                )}
              </div>
              <div
                className={
                  memberFocus ? 'mb-[12px] text-[14px] text-purple-500' : 'mb-[12px] text-[14px] text-gray-700'
                }
              >
                {isLocaleKO ? member?.name : member?.name_en}
              </div>
              <div className="mb-2 pr-16 text-[12px] text-gray-500">
                {member?.position}, {member?.city}
              </div>
              <div className="transition-all-200 member-desc text-[12px] text-black">{changingText}</div>
            </Col>
          </div>
        </>
      ) : (
        <Col
          col12
          clx="bg-white transition-all-200 member-card-lg"
          onMouseEnter={() => showCasualIntro()}
          onMouseLeave={() => hideCasualIntro()}
        >
          <div className="relative mb-12 flex">
            <div className="pr-20">
              <img
                src={changingImg}
                width={150}
                height={150}
                className={'pointer-events-none rounded-full bg-gray-200'}
              />
              <div className="link-icons absolute bottom-0 right-10">
                {member?.homepage && (
                  <a href={member?.homepage} className="">
                    <img src={IC_HOME} className="w-[22px]" />
                  </a>
                )}
              </div>
            </div>
          </div>
          <div
            className={classNames(
              memberFocus ? 'text-20 font-bold text-purple-500' : 'text-20 font-bold text-gray-700'
            )}
          >
            {isLocaleKO ? member?.name : member?.name_en}
          </div>
          <div
            className={classNames(
              member?.position.length > 30 && !lead && 'inline',
              'text-sBody font-medium text-gray-700'
            )}
          >
            {member?.position}
          </div>
          <div
            className={classNames(member?.position.length > 30 && !lead && 'inline pl-4', 'text-sBody text-gray-500')}
          >
            {member?.city}
          </div>
          <div className="text-sBody member-desc mt-12 text-gray-700">{changingText}</div>
        </Col>
      )}
    </>
  )
}

const TeamPage = ({ json, ogData }: InitialProps) => {
  console.log(json)
  const { t, isLocaleKO } = useTranslation()
  const department = json?.department
  const members = json?.members
  return (
    <NewBasicContainer landing ogData={ogData as IOgData}>
      <TailwindWrapper>
        <VWContainer>
          <CenterContainer clx="pt-[40px]">
            <LinkLocale href={`${urls.company.index}?type=list`}>
              <div className="flex items-center text-[14px] font-medium text-purple-500">
                <FeatherChevronLeft className="mr-[4px]" /> Back to {isLocaleKO ? '링글 팀 소개' : 'Team'}
              </div>
            </LinkLocale>
            <div className="mt-[60px]">
              <div className="text-[20px] font-bold text-purple-700 sm:text-[40px]">{department.team_name}</div>
              <div className="mt-[32px] text-[14px] text-black">
                {department.key == 'co-founder' ? 'Introduction' : 'Team Introduction'}
              </div>
              <div className="mt-[8px] text-[14px] font-bold text-black sm:text-[20px]">
                {isLocaleKO ? department.title : department.title_en}
              </div>
              <div className="mt-[32px] text-[12px] font-medium text-gray-700 sm:text-[16px]">
                {isLocaleKO ? department.description : department.description_en}
              </div>
              <div className="border-t-1 mt-[60px] grid grid-cols-1 border-gray-200 sm:grid-cols-4 sm:gap-[40px] sm:pt-[60px]">
                {members.map((item, i) => {
                  return <MemberCard key={i} member={item} />
                })}
              </div>
              <div className="hidden sm:mt-[32px] sm:block">
                <div className="mx-auto h-[99px] w-[1px] bg-gray-100"></div>
              </div>
              <hr className="mt-[28px] block sm:hidden" />
              {department.key == 'co-founder' ? (
                <div className="mt-[40px] text-center sm:mt-[20px]">
                  <div className=" text-[14px] font-bold text-purple-700 sm:text-[20px]">
                    {isLocaleKO
                      ? `성장하고 있는 링글의 다양한 히스토리가 궁금하다면`
                      : `Want to know more about Ringle's journey?`}
                  </div>
                  <a href="https://brunch.co.kr/@seunghoon82" target="_blank" rel="noreferrer">
                    <Button lg outlined clx="mt-[32px] sm:mt-[40px]">
                      {isLocaleKO ? '승훈님의 Brunch 보러가기' : `Visit Hoon Lee's blog`}
                    </Button>
                  </a>
                </div>
              ) : (
                <div className="mt-[40px] text-center sm:mt-[20px]">
                  <div className=" text-[14px] font-bold text-purple-700 sm:text-[20px]">
                    {isLocaleKO
                      ? `${department?.team_name}에 지원해보세요.`
                      : `Learn how you can to join our ${department?.team_name} team.`}
                  </div>
                  <a href="https://career.ringleplus.com/" target="_blank" rel="noreferrer">
                    <Button lg outlined clx="mt-[32px] sm:mt-[40px]">
                      {isLocaleKO ? '상세 채용공고 확인하기' : 'See Details (Written in Korean)'}
                    </Button>
                  </a>
                </div>
              )}
            </div>

            {/* <TeamBody departments={json} /> */}
            <EmptyBlock h={100} />
          </CenterContainer>
        </VWContainer>
        <Footer showMenu dark />
      </TailwindWrapper>
    </NewBasicContainer>
  )
}
TeamPage.getInitialProps = async (context: NextPageContext) => {
  const json = await axiosGet(apis.ringleTeam.departmentsDetail(context.query.id))
  const { lang = LOCALE_KO } = context.query
  const ogData = {
    title: lang == LOCALE_KO ? '링글 팀 소개' : 'Ringle Team',
    desc:
      lang == LOCALE_KO
        ? '링글은 누구나 영어의 장벽을 넘어 더 큰 기회를 잡을 수 있는 세상을 만듭니다'
        : 'Ringle team aims to become the world’s number one Edu-Tech company by creating a service that fosters true learning and growth through our selective tutors, contents and technology',
    image: TEAM_MAIN,
    ogUrl: getOgUrl({ lang, context }),
  }
  return {
    json,
    ogData,
  }
}

export default TeamPage
